import m from 'mithril';
import {trans} from "./helpers";

let challenge_state = {
    id_challenge: false,
    types: [],
    exercises : [],
    loaded : false,
    challenge : {
        id_type : null,
        title: null,
        url_poster: null,
        data : {},
        exercises : [
            // {
            //     id_exercise: 219,
            //     type: 'repetitions',
            //     val: 1
            // },
        ]
    },

    curr_thumbnail: {
        id_image: null,
        status: 'und',
    },

    is_admin : SPORTNETXPAGE.USER && SPORTNETXPAGE.USER.roles.includes("Fit Admin")
}

window.challenge_state = challenge_state;

// console.log(window.challenge_state)

class IsAvailableSelector {
    view() {
        if(! challenge_state.id_challenge) {
            return;
        }
        
        if(! challenge_state.loaded) {
            return '';
        }
        
        if(!challenge_state.is_admin) {
            return '';
        }

        if(challenge_state.challenge.available == 1) {
            return m('div.admin-btn-selector', [
                'Challenge IS AVAILABLE.',
                m('div.btn', {
                    onclick : _ => {
                        update_challenge({'available' : 0})
                    }
                },'CHANGE TO COMING SOON')
            ])
        } else if(challenge_state.challenge.available == 0) {
            return m('div.admin-btn-selector', [
                'Challenge IS COMING SOON.',
                m('div.btn', {
                    onclick : _ => {
                        update_challenge({'available' : 1})
                    }
                },'MAKE IT AVAILABLE')
            ])
        }
    }
}

class IsPublicSelector {
    view() {
        if(! challenge_state.id_challenge) {
            return;
        }
        if(! challenge_state.loaded) {
            return '';
        }

        if(challenge_state.challenge.public == 1) {
            return m('div.admin-btn-selector', [
                'Challenge IS PUBLIC.',
                m('div.btn', {
                    onclick : _ => {
                        update_challenge({'public' : 0})
                    }
                },'HIDE IT')
            ])
        } else if(challenge_state.challenge.public == 0) {
            return m('div.admin-btn-selector', [
                'Challenge IS PRIVATE.',
                m('div.btn', {
                    onclick : _ => {
                        update_challenge({'public' : 1})
                    }
                },'MAKE IT PUBLIC')
            ])
        }
    }
}

class IsAprovedRejectedSelector {
    view() {
        if(! challenge_state.id_challenge) {
            return;
        }
        if(! challenge_state.loaded) {
            return '';
        }
        if(!challenge_state.is_admin) {
            return '';
        }

        if(challenge_state.challenge.validated == 1) {
            return m('div.admin-btn-selector', [
                'Challenge is approved.',
                m('div.btn', {
                    onclick : function() {
                        update_challenge({'reject' : 1})
                    }
                },'REJECT IT')
            ])
        }else if(challenge_state.challenge.rejected == 1) {
            return m('div.admin-btn-selector', [
                'Challenge is rejected.',
                m('div.btn', {
                    onclick : function() {
                        update_challenge({'approve' : 1})
                    }
                }, 'APPROVE IT')
            ])
        }
        return m('div.admin-btn-selector', [
            'Challenge needs to be approved or rejected.',
            m('div.btn', {
                onclick : function() {
                    update_challenge({'reject' : 1})
                }
            }, 'REJECT IT'),
            m('div.btn', {
                onclick : function() {
                    update_challenge({'approve' : 1})
                }
            }, 'APPROVE IT')
        ])
    }
}

class TypeSelectorVars {
    view() {
        let vars = []
        if(challenge_state.challenge.id_type == 1) {
            vars = [
                'x'
            ]
        }else if(challenge_state.challenge.id_type == 3) {
            vars = [
                'y'
            ]
        }
        return vars.map(_v => {
            return m('.line', [
                m('.line-element', [
                    m('label', trans('challenge.variable') + ' ' + _v),
                    m('input', {
                        placeholder: _v,
                        type: 'text',
                        value: challenge_state.challenge.data[_v] ? challenge_state.challenge.data[_v] : '',
                        onchange: _dom => challenge_state.challenge.data[_v] = _dom.target.value
                    })
                ])
            ])
        })
    }
}

class CustomThumbnailSelector {
    view() {
        return [
            m('.line', [
                m('.line-element', [
                    m('label', trans('common.custom_thumbnail')),
                    m('.btn', {
                        onclick: e => change_thumbnail()
                    }, trans('common.change_thumbnail_btn')),

                    challenge_state.curr_thumbnail.status == 'uploading' &&
                    m('div', trans('challenge.loading'))
                ]),
            ]),
            challenge_state.challenge.url_poster &&
            m('.line', [
                m('.line-element', [
                    m('img', { 
                        src: challenge_state.challenge.url_poster, 
                        // style: "max-width:100%; height:auto;"
                        width: 300,
                        height: 150,
                    })
                ])
            ])
        ]
    }
}

class AvailableExercises{
    view() {
        return [
            m('h2', trans('challenge.exercises_in_challenge')),
            m('div.exercise_chooser', challenge_state.exercises.map(_ex => {
                let _class = '.exercise_chooser__split';
                let is_included = challenge_state
                    .challenge
                    .exercises
                    .filter(_ex1 => _ex1.id_exercise == _ex.id_exercise).length > 0
                let _ex_obj = null;

                if(is_included) {
                    _class += '.exercise_chooser__split--included'
                    for(let _ex_ii of challenge_state.challenge.exercises) {
                        if(_ex_ii.id_exercise == _ex.id_exercise) {
                            _ex_obj = _ex_ii;
                            if(!_ex_obj['type']) {
                                _ex_obj['type'] = 'repetitions'
                                _ex_obj['val'] = 1
                            }
                        }
                    }
                }
                return m('div' + _class, {
                    onclick : () => {
                        if(is_included) {
                            return;
                        }
                        challenge_state.challenge.exercises.push(Object.assign({},_ex))
                    }
                },[
                    m('div.exercise_chooser__img', {
                        style: 'background-image: url("' + _ex.url_poster + '")'
                    }),
                    m('div.exercise_chooser__rest', [
                        m('div.exercise_chooser__title', _ex.title),
                        m('div.exercise_chooser__desc', _ex.short_description),

                        is_included && m('div.exercise_chooser__type_and_val', [
                            m('select', {
                                value : _ex_obj.type,
                                onchange: e => {
                                    _ex_obj.type = e.target.value
                                    if(_ex_obj.type == 'no_limit') {
                                        _ex_obj.val = 0
                                    }
                                }
                            },[
                                m('option', { value: 'repetitions' }, 'Repetitions'),
                                m('option', { value: 'time' }, 'Time'),
                                m('option', { value: 'no_limit' }, 'No limit'),
                            ]),
                            _ex_obj.type != 'no_limit' && m('input', {
                                placeholder : 'reps or time in sec',
                                value: _ex_obj.val,
                                size: 5,
                                type: 'number',
                                min: '1',
                                onchange: e => _ex_obj.val = e.target.value
                            }),
                            _ex_obj.type == 'time' && m('span', ' Seconds')
                        ]),
                    ]),
                    m('div.exercise_chooser__include_exclude', [
                        is_included && m('div.exercise_chooser__btn.btn', {
                            onclick : function() {
                                if(! confirm(trans('challenge.confirm_remove_exercise'))) {
                                    return;
                                }
                                for(let ii = 0; ii < challenge_state.challenge.exercises.length; ii++) {
                                    if(challenge_state.challenge.exercises[ii].id_exercise == _ex.id_exercise) {
                                        challenge_state.challenge.exercises.splice(ii, 1);
                                    }
                                }
                                // for()
                                // challenge_state.challenge.exercises.push(Object.assign({},_ex))
                            }
                        },'Exclude'),
                        !is_included && m('div.exercise_chooser__btn.btn', {
                            onclick : function() {

                            }
                        }, 'Include'),
                    ])
                ])
            }))
        ]
    }
}


class ChallengeEditor {
    oninit() {
        get_types()
        if(challenge_state.id_challenge) {
            get_challenge()
            // get users exercises
        }else{
            get_my_exercises()
        }
    }
    view(vnode) {
        return  m('div', [
            m('.ijf-form', [
                m('.line', [
                    m('.line-element', [
                        !challenge_state.id_challenge && m('label', trans('challenge.new_challenge')),
                        m('input', {
                            placeholder: 'eg. How many 180 burpees in 30 seconds',
                            type: 'text',
                            value: challenge_state.challenge.title,
                            onchange: _dom => {
                                challenge_state.challenge.title = _dom.target.value
                            }
                        })
                    ]),
                ]),
                m('.line', [
                    m('.line-element', [
                        m('label', trans('challenge.form.description')),
                        m('input', {
                            placeholder: 'eg. You need to do this for 30 seconds, make sure you follow exercises correctly',
                            type: 'text',
                            value: challenge_state.challenge.description,
                            onchange: _dom => {
                                challenge_state.challenge.description = _dom.target.value
                            }
                        })
                    ]),
                ]),
                m(IsPublicSelector),
                m(IsAprovedRejectedSelector),
                m(IsAvailableSelector),
                m(AvailableExercises),
                m('.line', [
                    m('.line-element', [
                        m('label', trans('challenge.select_type')),
                        m('select', {
                            value: challenge_state.challenge.id_type,
                            onchange: _s => challenge_state.challenge.id_type = _s.target.value
                        }, challenge_state.types.map(_t => {
                            return m('option', {
                                value: _t.id_type
                            }, _t.title)
                        }))
                    ]),
                ]),
                m('.line', [
                    m('.line-element.line-element--checkbox', [
                        m('b', trans('challenge.is_only_kids')),
                        m('input', {
                            name: 'only_kids',
                            id: 'only_kids',
                            type: 'checkbox',
                            checked: challenge_state.challenge.only_kids == 1,
                            onclick: e => challenge_state.challenge.only_kids = challenge_state.challenge.only_kids == 1 ? 0 : 1
                        })
                    ]),
                ]),
                m(TypeSelectorVars),
                challenge_state.id_challenge &&
                m(CustomThumbnailSelector),
                m('.line.line--center',
                    m('.btn.btn--full-width.btn--main', {
                        type: 'submit',
                        onclick: e => {
                            if(challenge_state.id_challenge) {
                                update_challenge()
                            }else{
                                insert_challenge()
                            }

                        }
                    }, trans('challenge.save_bnt'))
                )
            ])
        ]);
    }
}


function get_my_exercises() {
    let url = '/api/exercises?visibility=all'
        // get_my_exercises()
    if(challenge_state.challenge && challenge_state.challenge.id_user) {
        url += '&id_user=' + challenge_state.challenge.id_user
    }else{
        url += '&mine=1';
    }
    m.request(url)
        .then(d => {
            challenge_state.exercises = d;
        }).catch(err => {
            alert('Something went wrong, please refresh page.')
        })
}

function get_types() {
    m.request('/api/challenge_types').then(d => {
        challenge_state.types = d.feed;
        if(challenge_state.id_challenge) {

        }else{
            challenge_state.challenge.id_type = 1; // only set default ifcreating new challenge
        }
    }).catch(err => {
        alert('Something went wrong, please refresh page.')
    })
}

function toggleChallengePublic(what) {
    if(! confirm('This will also save any changes. Confirm')) {
        return;
    }
}

function toggleChallengeApproveReject(what) {
    if(! confirm('This will also save any changes. Confirm')) {
        return;
    }
}

function get_challenge() {
    challenge_state.loaded = true;
    m.request('/api/challenge?part=info,exercises&id_challenge=' + challenge_state.id_challenge)
        .then(d => {
            // api returns [] for empty arrays, need to be sure to have it as object for JS
            if(Object.values(d.data) == 0 || !d.data) {
                d.data = {}
            }
            d.exercises = d.exercises.map(_e => {

                let type = 'no_limit'
                let val = 0;
                if(_e.seconds > 0) {
                    type = 'time';
                    val = _e.seconds;
                }else if(_e.repetitions > 0) {
                    type = 'repetitions';
                    val = _e.repetitions;
                }

                return {
                    id_exercise: _e.id_exercise * 1,
                    type: type,
                    val:  val
                };
            })
            challenge_state.challenge = d

            get_my_exercises()

        }).catch(err => {
            console.log(err)
            alert('Something went wrong, please refresh page.')
        })
}

function obj_to_array(obj) {
    let ret = []
    for(let ii in obj) {
        ret[ii] = obj[ii]
    }
    return ret;
}

function update_challenge(more) {
    let update_data = {
        id_challenge: challenge_state.id_challenge,
        title : challenge_state.challenge.title,
        id_type : challenge_state.challenge.id_type,
        only_kids : challenge_state.challenge.only_kids,
        data : challenge_state.challenge.data,
        exercises : challenge_state.challenge.exercises,
        description : challenge_state.challenge.description,
        url_poster : challenge_state.challenge.url_poster,
    }
    if(more) {
        update_data = Object.assign(update_data, more)
    }

    m.request({
        method: "POST",
        url: "/api/challenge",
        responseType: "json",
        body: update_data
    }).then(d => {
        alert('Congratulations! Challenge was updated.')
        get_challenge()
    }).catch(e => {
        console.log(e)
        alert('Problem saving. try again')
    })
}

function insert_challenge() {
    m.request({
        method: "POST",
        url: "/api/challenge",
        responseType: "json",
        body: challenge_state.challenge
    }).then(d => {
        if(! challenge_state.id_challenge && d.id_challenge > 0) {
            alert('Congratulations! Challenge was created. It will become available to everyone once it gets approved by IJF team.')
            document.location.href = '/challenge/edit/' + d.id_challenge
        }else{
            alert('Congratulations! Challenge was updated.')
        }
    }).catch(e => {
        console.log(e)
        alert('Problem saving. try again')
    })
}

function change_thumbnail() {
    var input = document.createElement('input');

    input.type = 'file';
    input.accept = 'image/*';

    input.onchange = e => { 
        var file = e.target.files[0];

        let extension = file.name.split('.').pop().toLowerCase();

        if(extension != 'png' && extension != 'jpg' && extension != 'jpeg' && extension != 'gif') {
            alert("Wrong file format. Supported: .png, .jpg and .gif");
            return;
        }

        let data = {
            type: 'image',
            entity: 'challenge',
            id_entity: challenge_state.id_challenge,
            file: {
                name: file.name,
                size: file.size,
                type: file.type
            }
        };

        m.request({
            method: "POST",
            url: "/api/media",
            body: data
        }).then(function(data) {
            if(data.status == 200) {  
                challenge_state.curr_thumbnail.id_image = data.id_uploaded;

                upload_image(file, data.id_uploaded, data.upload_url);
            } else {
                alert("ERROR!");
            }
        });
    }

    input.click();
}

function upload_image(file, id_image, upload_url) {
    challenge_state.curr_thumbnail.status = 'uploading';

    var xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("PUT", upload_url, true);

    xmlHttpRequest.setRequestHeader("Content-Type", file.type);

    xmlHttpRequest.upload.addEventListener("progress", function(e) {
        let progress = (e.loaded / e.total) * 100;
        progress = Math.floor(progress);
        if(progress >= 100) {
            progress = 100;

            setTimeout(function() {
                m.request({
                    method: "GET",
                    url: '/api/media/upload_image_finished/' + id_image,
                }).then(function(data) {
                    if(data.status == 200) {
                        console.log('UPLOADED!');
                        m.request({
                            method: "GET",
                            url: "/api/media/get_image/"+challenge_state.curr_thumbnail.id_image,
                        }).then(function(data) {
                            if(data.status == 200) {
                                challenge_state.challenge.url_poster = data.image.public_url;
                            }
                            challenge_state.curr_thumbnail.status = 'finished';
                        }).catch(err => {
                            alert('Something went wrong, please refresh page.')
                        });
                    } else {
                        alert('Something went wrong, please refresh page.')
                    }
                }).catch(err => {
                    alert('Something went wrong, please refresh page.')
                });
            }, 2000)
        }

        m.redraw()
    });

    xmlHttpRequest.send(file);
}

function init(rootElement, id_challenge) {

    if(!rootElement) {
        return;
    }

    challenge_state.id_challenge = id_challenge;

    m.mount(rootElement, ChallengeEditor);
}

export default init;
